import { render } from "./k-no-permission.vue?vue&type=template&id=277f1340"
import script from "./k-no-permission.vue?vue&type=script&lang=js"
export * from "./k-no-permission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__